import script from "./GuestOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GuestOverlay.vue?vue&type=style&index=0&id=0bcbae82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bcbae82"]])

export default __exports__